var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('vx-card',[_c('role-editor',{attrs:{"role":_vm.role}})],1)],1)],1),(_vm.role)?_c('b-row',[_c('b-col',[_c('permissions',{attrs:{"role":_vm.role}})],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }